import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface User {
  id: number
  username: string
  display_name: string | null
  default_company_id: number | null
  is_master?: boolean
  can_analyze?: boolean   // 회사관리 '분석' 탭(관리자는 항상)
}

export interface Company {
  id: number
  name: string
  biz_no: string | null
  rep_name: string | null
  biz_type: '법인' | '개인'
  biz_kind?: string
  biz_item?: string
  address?: string
  tel?: string
  fax?: string
  invoice_style?: 'common' | 'greenseoul' | 'marufarm' | 'dawon'
  label_group?: string
  sales_merge_into?: number | null
  seal?: string
  is_default: boolean
  is_active: boolean
}

// 회사는 이제 창별 URL(?company=id)이 단일 소스 — 공유 localStorage 에 두지
// 않는다(창 간 회사 오염 방지). token/user 만 지속. 회사 객체는 useCurrentCompany.
interface AuthState {
  token: string | null
  user: User | null

  setToken: (t: string | null) => void
  setUser: (u: User | null) => void
  logout: () => void
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setToken: (t) => set({ token: t }),
      setUser: (u) => set({ user: u }),
      logout: () => set({ token: null, user: null }),
    }),
    { name: 'gf-auth' }
  )
)
